function menuValueRole (item, visibleChildCount) {

  if (!item || item.type !== 'value') return ''
  if (visibleChildCount > 0) return 'dropdown'
  if (item.pageUniqueTitle) return 'link'

  return 'text'
}

function menuChildRole (child, visibleChildCount) {

  if (!child) return 'text'
  if (child.type === 'code') return 'code'
  if (child.type === 'dropdown') return visibleChildCount > 0 ? 'submenu' : ''
  if (child.type === 'value') {

    if (visibleChildCount > 0) return 'submenu'
    if (child.pageUniqueTitle) return 'link'

    return 'text'
  }

  return 'page'
}

function menuEntryRole (item, depth, visibleChildCount) {

  const count = depth >= 4 ? 0 : visibleChildCount

  if (!item) return ''
  if (item.type === 'code') return 'code'
  if (depth === 1) {

    if (item.type === 'link') return 'page'
    if (item.type === 'dropdown') return 'dropdown'

    return menuValueRole(item, count)
  }

  return menuChildRole(item, count)
}

menuValueRole.menuChildRole = menuChildRole
menuValueRole.menuEntryRole = menuEntryRole

module.exports = menuValueRole
